module.exports = __webpack_public_path__ + "static/media/CTLI_7-235w.42d47089.png";